/**
 * @generated SignedSource<<73c5d7dce6584f5be3d45dfe6a4643cd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UnfollowTopicInput = {
  topicSlug: string;
};
export type PodcastPageUnfollowMutation$variables = {
  input: UnfollowTopicInput;
};
export type PodcastPageUnfollowMutation$data = {
  readonly unfollowTopic: {
    readonly topic: {
      readonly followerCount: number;
      readonly id: string;
      readonly isFollowedByViewer: boolean | null | undefined;
    } | null | undefined;
    readonly userErrors: ReadonlyArray<{
      readonly field: string | null | undefined;
      readonly message: string;
    }>;
  };
};
export type PodcastPageUnfollowMutation = {
  response: PodcastPageUnfollowMutation$data;
  variables: PodcastPageUnfollowMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UnfollowTopicPayload",
    "kind": "LinkedField",
    "name": "unfollowTopic",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Topic",
        "kind": "LinkedField",
        "name": "topic",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isFollowedByViewer",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "followerCount",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "userErrors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PodcastPageUnfollowMutation",
    "selections": (v1/*: any*/),
    "type": "MutationRoot",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PodcastPageUnfollowMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "46d371ecfc877f9d19fbc36a90ad73f1",
    "id": null,
    "metadata": {},
    "name": "PodcastPageUnfollowMutation",
    "operationKind": "mutation",
    "text": "mutation PodcastPageUnfollowMutation(\n  $input: UnfollowTopicInput!\n) {\n  unfollowTopic(input: $input) {\n    topic {\n      id\n      isFollowedByViewer\n      followerCount\n    }\n    userErrors {\n      message\n      field\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3da55a7c5953f24ffcbc6a8f1e3acb1c";

export default node;
